// ---------------------------------------------------------------------------
// P1 (?dbg=1): mede a CPU da submissão (renderer.render, relógio ao redor) e lê renderer.info (chamadas, triângulos,
// linhas) LOGO DEPOIS de cada desenho (P1b T6a: lido no quadro seguinte, o autoReset podia zerar antes da leitura —
// no autoplay 180 vinha 0). Só diagnóstico: o render é chamado com os mesmos argumentos e o resultado não muda.
// Sem a flag o hook não faz nada.
// ---------------------------------------------------------------------------
import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';
import { DBG_ENABLED } from '../../utils/dbgFlag';
import { p1 } from '../../utils/p1Probe';

export function useRenderProbe(): void {
  if (!DBG_ENABLED) return;
  // eslint-disable-next-line react-hooks/rules-of-hooks -- DBG_ENABLED é constante do módulo: a ordem dos hooks não muda
  const gl = useThree(s => s.gl);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const orig = gl.render;
    gl.render = function (this: any, scene: any, camera: any) {
      const t = performance.now();
      orig.call(this, scene, camera);
      p1!.addRender(performance.now() - t);
      const r = gl.info.render;
      p1!.info(r.calls, r.triangles, r.lines);
    } as typeof gl.render;
    return () => { gl.render = orig; };
  }, [gl]);
}
